"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const LoginErrorNotification_1 = __importDefault(require("./LoginErrorNotification"));
const LoginSocial_1 = __importDefault(require("./LoginSocial"));
const RegisterButtonLink_1 = __importDefault(require("./RegisterButtonLink"));
const LayoutWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    backgroundColor: 'bgLightBlue',
    pt: [0, '45px'],
    pb: [0, '75px'],
}));
const layoutBlockStyles = {
    width: ['100%', '50%'],
    py: [4, '50px'],
    px: [4, '62px'],
};
const LayoutBlockWrapper = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({ display: 'flex' }, theme.auth.loginLayoutBlockStyles)));
const LayoutBlock = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(layoutBlockStyles, {
    borderRight: [null, '1px solid'],
    borderColor: [null, 'borderColor'],
    '.form-title': theme.auth.formTitleStyles,
}));
const RegistrationBlock = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(layoutBlockStyles, {
    '.form-title': theme.auth.formTitleStyles,
}));
const LoginSocialTop = styled_components_1.default.div(({ theme }) => theme.auth.loginSocialTop);
const B2CLoginLayout = props => {
    const { children, loginTitle, registerTitle, registerIntroText } = props;
    const [t] = (0, next_i18next_1.useTranslation)(['auth', 'forms']);
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    return (react_1.default.createElement(LayoutWrapper, null,
        react_1.default.createElement(LayoutBlockWrapper, null,
            react_1.default.createElement(LayoutBlock, { "data-id": "login-section" },
                !mobile && (react_1.default.createElement("h2", { className: "form-title", "data-id": "layout-title" }, loginTitle)),
                children),
            !mobile && (react_1.default.createElement(RegistrationBlock, { "data-id": "registration-section" },
                react_1.default.createElement("h2", { className: "form-title", "data-id": "registration-title" }, registerTitle),
                react_1.default.createElement("div", { className: "layout-text", dangerouslySetInnerHTML: { __html: registerIntroText } }),
                react_1.default.createElement(RegisterButtonLink_1.default, null))),
            react_1.default.createElement(LoginSocialTop, null,
                react_1.default.createElement("span", { className: "decoration-line-span" }),
                react_1.default.createElement("div", { className: "or-span" }, t('forms:or.span')),
                react_1.default.createElement("span", { className: "decoration-line-span" })),
            react_1.default.createElement(LoginSocial_1.default, null)),
        react_1.default.createElement(LoginErrorNotification_1.default, null)));
};
exports.default = B2CLoginLayout;
//# sourceMappingURL=B2CLoginLayout.js.map